import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useTranslation } from 'react-i18next'

export const ScreeningFollowUpPending = () => {
  const { t } = useTranslation()
  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.followUpPendingPage')}
      screeningTitle={t('employee.screening.followUpPendingTitle')}
      screeningDescription={t('employee.screening.followUpPendingDescription')}
      hideButton
    />
  )
}
